import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.li`
  display: block;
`;

export const ImageBox = styled.div<{ imageRatio?: string; selected?: boolean }>`
  ${({ theme, imageRatio, selected }) => css`
    position: relative;
    padding-bottom: ${imageRatio};
    overflow: hidden;
    border: 1px solid
      ${selected ? theme.themeColor.main_1 : theme.backgroundColor.divider};
    border-radius: 8px;

    & > img {
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: 100%;
      transform: translate(-50%, -50%);
      object-fit: cover;
    }
  `}
`;

export const TitleBox = styled.div`
  display: block;
`;

export const Title = styled.span`
  ${({ theme }) => css`
    display: block;
    width: 100%;
    color: ${theme.content.hierarchy2};
    ${theme.fontStyle.label.list14_medium}
    ${theme.mixins.text.ellipsis_2}
  `}
`;
export const ReviewBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
  `}
`;
export const IconBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;

    i {
      width: 24px;
      height: 24px;

      svg {
        width: 100%;
        height: 100%;
        color: ${theme.content.content_light_1};
      }
    }
  `}
`;

export const Review = styled.div`
  ${({ theme }) => css`
    color: ${theme.content.caption1};
    ${theme.fontStyle.label.list12_medium}
  `}
`;
